import type { ThemeUICSSObject } from 'theme-ui';

export type BoxVariant = 'default' | 'bordered';

const boxDefault: ThemeUICSSObject = {};

export const layout: Record<'box' | `box_${BoxVariant}`, ThemeUICSSObject> = {
	box: boxDefault,
	box_default: boxDefault,
	box_bordered: {
		borderRadius: 'standard',
		borderColor: 'neutral-grey400',
		borderStyle: 'solid',
		borderWidth: 1,
	},
};
